<template>
  <div class="home">
    <!-- Hero Slider -->
    <div class="hero-section">
      <el-carousel
        height="500px"
        :interval="5000"
        arrow="always"
        indicator-position="outside"
      >
        <el-carousel-item v-for="(image, index) in carouselImages" :key="index">
          <div
            class="carousel-content"
            :style="{ backgroundImage: `url(${image.url})` }"
          >
            <div class="carousel-overlay">
              <h2 class="cursive-font">Best Service Attitude</h2>
              <div class="carousel-text">
                <p>
                  We believe that the priority of service attitude is above all
                  else.
                </p>
                <p>
                  A good service attitude allows you to have a five-star massage
                  experience.
                </p>
                <p>
                  We are honored to have done this, and the guests who have been
                  here are full of praise for our service attitude.
                </p>
              </div>
              <div class="carousel-buttons">
                <el-button type="primary" @click="callPhone"
                  >CALL US AT 888-888-888</el-button
                >
                <!-- <el-button type="info" @click="goToBooking"
                  >BOOK ONLINE NOW</el-button
                > -->
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- About Section -->
    <section class="about-section">
      <div class="container">
        <el-row :gutter="30">
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <div class="about-content">
              <!-- <h2>About All Asian Massage 6</h2> -->
              <h2>About Massage</h2>
              <p>
                Your licensed massage therapist at Massage is customized to
                relax and peace your body and mind, whose technique will be
                uniquely tailored to fit your inner body. You'll quickly unwind
                and relieve any built-up stress you may have from your work and
                home. We invite you to reach your goals of stress reduction,
                relaxation and pain relief, combined with our skillful massage
                and rejuvenating methods. We also offer couple and group
                sessions to enjoy with your loved ones and friends. You are
                welcome to call us at 888-888-888 to make appointment! We are
                looking forward to serve you. Thank you!
              </p>
              <el-button type="primary" @click="$router.push('/about')"
                >LEARNING MORE</el-button
              >
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <div class="about-image">
              <img
                src="https://ext.same-assets.com/897945139/4004652302.jpeg"
                alt="Couple Massage"
                class="img-responsive"
              />
            </div>
          </el-col>
        </el-row>
      </div>
    </section>

    <!-- Services Preview -->
    <section class="services-preview">
      <div class="container">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12" :md="8">
            <div class="service-card">
              <div class="service-image">
                <img
                  src="https://ext.same-assets.com/3353456279/150212513.jpeg"
                  alt="Combo Massage"
                />
              </div>
              <h3>Combo Massage</h3>
              <p>
                A Combination Massage is a massage integrating more than one
                style or massage modality. It can combine techniques from
                swedish massage, deep tissue massage, reflexology, trigger point
                therapy and hot stone.
              </p>
              <el-button type="text" @click="$router.push('/services')"
                >Learn More</el-button
              >
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <div class="service-card">
              <div class="service-image">
                <img
                  src="https://ext.same-assets.com/1074918731/4007225628.jpeg"
                  alt="Body Massage"
                />
              </div>
              <h3>Body Massage</h3>
              <p>
                The benefits of body massage include increased blood
                circulation, mental and physical relaxation, decreased stress
                and muscle tension, and improved range of motion. It involves
                the use of hands, forearms or elbows to manipulate the
                superficial layers of the muscles to improve mental and physical
                health.
              </p>
              <el-button type="text" @click="$router.push('/services')"
                >Learn More</el-button
              >
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8">
            <div class="contact-info">
              <h3>Contact Us</h3>
              <el-form>
                <el-form-item label="Name" required>
                  <el-input ref="nameInput"></el-input>
                </el-form-item>
                <el-form-item label="Phone" required>
                  <el-input ref="phoneInput"></el-input>
                </el-form-item>
                <el-form-item label="Write a message">
                  <el-input
                    type="textarea"
                    rows="4"
                    ref="messageInput"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="sendContactEmail"
                    >Send</el-button
                  >
                </el-form-item>
              </el-form>
            </div>
          </el-col>
        </el-row>
      </div>
    </section>
  </div>
</template>

<script>
import { sendEmail } from "../utils/mail"

export default {
  name: "HomePage",
  data() {
    return {
      carouselImages: [
        { url: "https://ext.same-assets.com/2396158337/2699326776.jpeg" },
        { url: "https://via.placeholder.com/150/00FF00/FFFFFF?text=Image+2" },
        { url: "https://via.placeholder.com/150/0000FF/FFFFFF?text=Image+3" },
        { url: "https://via.placeholder.com/150/FFFF00/FFFFFF?text=Image+4" },
        { url: "https://via.placeholder.com/150/FF00FF/FFFFFF?text=Image+5" },
      ],
    }
  },
  methods: {
    callPhone() {
      window.location.href = "tel:888-888-888"
    },
    goToBooking() {
      window.open(
        "http://fresha.com/book-now/all-asian-massage-6-neg81tbo/services",
        "_blank"
      )
    },
    async sendContactEmail() {
      const to = "recipient@example.com" // 收件人邮箱
      const subject = "测试邮件" // 邮件主题
      const text = "这是邮件正文" // 邮件正文

      try {
        await sendEmail(to, subject, text) // 调用 sendEmail 函数
        console.log("邮件发送成功")
      } catch (error) {
        console.error("邮件发送失败", error)
      }
    },
  },
}
</script>

<style scoped>
.hero-section {
  margin-bottom: 3rem;
}

.carousel-content {
  height: 100%;
  background-size: cover;
  background-position: center;
  position: relative;
}

.carousel-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: white;
  padding: 2rem;
}

.carousel-overlay h2 {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.carousel-text {
  margin-bottom: 2rem;
}

.carousel-buttons {
  display: flex;
  gap: 1rem;
}

.about-section {
  padding: 3rem 0;
  background-color: #fff;
}

.about-content h2 {
  color: var(--secondary-color);
  margin-bottom: 1.5rem;
}

.about-image img {
  width: 100%;
  border-radius: 8px;
}

.services-preview {
  padding: 3rem 0;
}

.service-card {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 2rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  height: 530px;
  display: flex;
  flex-direction: column;
}

.service-image {
  height: 180px;
  overflow: hidden;
}

.service-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.service-card h3 {
  padding: 0.5rem 1rem;
  margin-bottom: 0;
  color: var(--secondary-color);
}

.service-card p {
  padding: 0 1rem;
  flex-grow: 1;
  height: auto;
  overflow: visible;
  font-size: 0.9em;
  margin: 0.5rem 0;
}

.service-card .el-button {
  margin: 0.5rem 1rem;
}

.contact-info {
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  height: 100%;
}

.contact-info h3 {
  margin-bottom: 1.5rem;
  color: var(--secondary-color);
}

.img-responsive {
  max-width: 100%;
  height: auto;
}

@media (max-width: 768px) {
  .carousel-overlay h2 {
    font-size: 2rem;
  }

  .carousel-buttons {
    flex-direction: column;
  }

  .about-content {
    margin-bottom: 2rem;
  }
}
</style>
